// extracted by mini-css-extract-plugin
export var notificationHost = "_kj-0";